import React from 'react'

import { useCorporateSelectData } from './hooks'

import { SelectAsync, shouldLoadMore } from '../SelectAsync'

import type { CorporateSelectProps } from './types'

export const CorporateSelect: React.FC<CorporateSelectProps> = ({
  requestParams,
  value: valueProp,
  isDisabled: isDisabledProp,
  ...restProps
}) => {
  const { request, isDisabled, value, placeholder } = useCorporateSelectData(
    requestParams,
    restProps.onChange
  )

  return (
    <SelectAsync
      placeholder={placeholder}
      cacheUniqs={[requestParams]}
      {...restProps}
      value={value ?? valueProp}
      isDisabled={isDisabledProp || isDisabled}
      request={request}
      shouldLoadMore={shouldLoadMore}
    />
  )
}
